/** Format a Rupiah amount as e.g. "Rp 2.999.000". */
export function formatIDR(amount: number): string {
  return "Rp " + amount.toLocaleString("id-ID");
}
